import styled from 'styled-components'

export const Wrapper = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-self: flex-start;
    text-decoration: none;
    cursor: pointer;
    font-weight: 300;
    margin: 25px auto;
    padding: 5px 50px;
    border: ${props => props.theme.border};
    border-radius: 40px;
    background: ${props => props.theme.background};
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    
    p {
        font-weight: 600;
        color: ${props => props.theme.color};
    }
    
    &:hover {
        background: ${props => props.theme.hover.background};
        p {
            color: ${props => props.theme.hover.color};
        }    
    }

    @media screen and (max-width: 430px) {
        margin: 30px auto;
        p {
            font-size: 1rem;
        }
    }
`;
